module.exports = __webpack_public_path__ + "img/admin_logo.780689a8.svg";